import { makeServiceCall } from 'redux-core/serviceHelpers';

export const getTemplateFileUrlCall = makeServiceCall('uploads', 'get-tracks-import-template-download-url');

export const getTracksImportUploadAccessCall = async ({ kind, contentType }) => {
  const call = makeServiceCall('uploads', 'upload-tracks-import-file');
  return call({ kind, contentType });
};

export const validateImportFileCall = async ({ s3FileKey, userId, productionId, cueContainerId, engine }) => {
  const call = makeServiceCall('tracks-import', 'validate', 'clear');
  /* QW-102 (plan §16): optional per-import engine override, bound to the job at
       creation. Omitted -> the server's TRACKS_IMPORT_ENGINE default decides. */
  return call({ s3FileKey, userId, productionId, cueContainerId, ...(engine && { engine }) });
};

export const processImportFileCall = async ({ jobId, divisionId }) => {
  const call = makeServiceCall('tracks-import', 'process', 'clear');
  return call({ jobId, divisionId });
};
